import { trackSearchEvent } from '../analytics/search';

export function trackRenderedSearchResults(root: HTMLElement): boolean {
  return trackSearchEvent(root);
}

export default function searchResults(root: HTMLElement): void {
  trackRenderedSearchResults(root);

  const list = root.querySelector<HTMLUListElement>('.search-results__list');
  const seeMoreWrap = root.querySelector<HTMLElement>('.search-results__see-more-wrap');
  const seeMoreBtn = root.querySelector<HTMLButtonElement>('[data-search-see-more]');

  if (!list || !seeMoreWrap || !seeMoreBtn) return;

  const total = parseInt(seeMoreWrap.dataset.total ?? '0', 10);
  let loaded = parseInt(seeMoreWrap.dataset.loaded ?? '0', 10);

  function updateSeeMoreVisibility(): void {
    if (loaded >= total) {
      seeMoreBtn!.hidden = true;
    }
  }

  updateSeeMoreVisibility();

  seeMoreBtn.addEventListener('click', async () => {
    const nextPage = Math.floor(loaded / 4) + 1;
    const url = new URL(window.location.href);
    url.searchParams.set('page', String(nextPage));
    url.searchParams.set('mobile-batch', '1');

    try {
      const res = await fetch(url.toString(), {
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      });

      if (!res.ok) return;

      const html = await res.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const newItems = doc.querySelectorAll<HTMLLIElement>(
        '.search-results__list > .search-results__item, .search-results__list > .search-results__item-divider'
      );

      newItems.forEach(item => {
        list.appendChild(item.cloneNode(true));
      });

      loaded += 4;
      seeMoreWrap!.dataset.loaded = String(loaded);
      updateSeeMoreVisibility();

      const liveRegion = document.createElement('span');
      liveRegion.className = 'sr-only';
      liveRegion.textContent = `${Math.min(loaded, total)} of ${total} results loaded.`;
      seeMoreWrap!.appendChild(liveRegion);
      setTimeout(() => liveRegion.remove(), 2000);
    } catch {
      // silent — server-rendered fallback handles the reload case
    }
  });
}
